import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer ist React.lazy,
 * sodass die Cockpit-Karte erst lädt, wenn die Projekt-Detailseite rendert.
 */
const manifest: SkillManifest = {
  key: 'project-assistant',
  name: 'Projekt-Cockpit',
  description:
    'Cockpit-Karte oben auf der Projekt-Detailseite — Stand, nächste Schritte, kritische Punkte und Blocker auf einen Blick.',
  category: 'ai',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ],
  enabledByDefault: true,
};

const CockpitCard = lazy(() => import('./CockpitCard').then((m) => ({ default: m.CockpitCard })));

export const projectAssistantSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.cockpit': [
      {
        key: 'cockpit-card',
        order: 10,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId+project
        render: CockpitCard,
      },
    ],
  },
};
